import { Router } from '@angular/router';
import { SolicitacaoService } from './../../../service/solicitacao/solicitacao.service';
import { AreaService } from './../../../service/cliente/area.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ClienteService } from './../../../service/cliente/cliente.service';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { AuthenticationService } from '@alfresco/adf-core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CaixaService } from './../../../service/caixa/caixa.service';
import { Component, OnInit } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { SolicitacaoModel } from 'app/model/solicitacao/solicitacao.model';
import {setTimeout} from 'timers';


@Component({
  selector: 'app-adicionar-solicitacao',
  templateUrl: './adicionar-solicitacao.component.html',
  styleUrls: ['./adicionar-solicitacao.component.scss']
})
export class AdicionarSolicitacaoComponent implements OnInit {

  public usuario;
  public loading = true;
  public solicitacaoForm: FormGroup;
  public submit = false;
  public clientes: ClienteModel[];
  public solicitacaoModel = {} as SolicitacaoModel;
  public areas: any[] = [];
  public disabledCod = true;
  public clienteCacheSolic;
  public areaCacheSolic;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  adm = false;
  acervo = false;
  solicitacao = true;
  solicitacoesConteudo: any[] = [];
  searchSolicitacoesConteudo = false;

  constructor(
    private authService: AuthenticationService,
    private caixaService: CaixaService,
    private fb: FormBuilder,
    private router: Router,
    private clienteService: ClienteService,
    private areaService: AreaService,
    private _snackBar: MatSnackBar,
    private solicitacaoService: SolicitacaoService) { }

  ngOnInit() {
    this.solicitacaoForm = this.fb.group({
      area: [null, Validators.required],
      cliente: [null, Validators.required],
      responsavelAbertura: ['', Validators.required],
      dataAbertura: [''],
      dataFechamento: [''],
      tipoDaSolicitacao: ['', Validators.required],
      dadosAdicionais: [''],
      solicitarConteudoId: ['']
    });
    this.getUserResponsavel(sessionStorage.getItem('ACS_USERNAME'));
    this.listarClientesUsuario();
    this.solicitacaoForm.get('area').disable();
    this.buscarCamposEmCache();
  }

  buscarCamposEmCache() {
    const cliente = localStorage.getItem('RM_CLIENTE_SOLIC_CACHE');
    const area = localStorage.getItem('RM_AREA_SOLIC_CACHE');
    if ((cliente !== null) && (area !== null)) {
      this.solicitacaoForm.get('cliente').setValue(JSON.parse(cliente));
      this.solicitacaoModel.cliente = JSON.parse(cliente);
      this.solicitacaoForm.get('area').enable();
      const clienteId = JSON.parse(cliente).id;
      this.listarAreasCliente(clienteId);
      this.solicitacaoForm.get('area').setValue(JSON.parse(area));
      this.solicitacaoModel.area = JSON.parse(area);
      this.disabledCod = false;
    }
  }

  getUserResponsavel(userId: string) {
    this.caixaService.getUsuarioCaixa(userId).subscribe(data => {
      this.usuario = data;
      this.solicitacaoForm.get('responsavelAbertura').setValue(this.usuario.nome);
      this.loading = false;
    }, err => {
      console.error(err);
    });
  }

  onSubmit() {
    this.submit = true;
    this.saveSolicitacao();
  }

  compararClienteEditCaixa(obj1, obj2) {
    return obj1 && obj2
      ? obj1.nome === obj2.nome && obj1.id === obj2.id
      : obj1 === obj2;
  }

  compararAreaEditCaixa(obj1, obj2) {
    return obj1 && obj2
      ? obj1.descricao === obj2.descricao && obj1.id === obj2.id
      : obj1 === obj2;
  }

  onChange(event) {
    this.clienteCacheSolic = this.solicitacaoForm.get('cliente').value;
    localStorage.setItem('RM_CLIENTE_SOLIC_CACHE', JSON.stringify(this.clienteCacheSolic));
    const idCliente = (this.solicitacaoForm.get('cliente').value).id;
    //this.idCliente = idCliente;
    //this.selectCliente = false;
    this.disabledCod = false;
    this.solicitacaoForm.get('area').enable();
    this.listarAreasCliente(idCliente);
    this.solicitacaoForm.get('area').enable();
    this.disabledCod = false;
    //this.listaArea = true;
  }

  onChangeArea() {
    this.areaCacheSolic = this.solicitacaoForm.get('area').value;
    localStorage.setItem('RM_AREA_SOLIC_CACHE', JSON.stringify(this.areaCacheSolic));
  }

  saveSolicitacao() {
    if (this.solicitacaoForm.valid) {
      this.solicitacaoForm.get('area').enable();
      this.solicitacaoService.adicionarSolicitacao(this.solicitacaoForm.value).subscribe(data => {
        console.log(data);
        this.openSnackBarSuccess(`Solicitação de ${data.tipoDaSolicitacao} salva com sucesso !`);
        const idCrypt = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(data.id), 'pcdoc').toString());
            setTimeout(() => {
                this.router.navigate(['/solicitacao', idCrypt]);
            }, 3000);
      }, err => {
        console.error(err);
        this.openSnackBarError(`Erro !`);
      });
    } else {
      this.openSnackBarError('Preencha todos os campos obrigatórios !');
    }

  }

  reset() {
    this.submit = false;
    this.disabledCod = true;
    this.solicitacaoForm.get('cliente').reset();
    this.solicitacaoForm.get('area').reset();
    this.solicitacaoForm.get('area').disable();
    this.solicitacaoForm.get('dataAbertura').reset();
    this.solicitacaoForm.get('dataFechamento').reset();
    this.solicitacaoForm.get('tipoDaSolicitacao').reset();
  }

  listarAreasCliente(idCliente: number) {
    this.areaService.getAreasUsuarioCliente(idCliente).subscribe(data => {
      this.areas = data;
      if (this.areas.length === 1) {
        this.solicitacaoForm.get('area').setValue(this.areas[0]);
      }
    }, err => {
      console.error(err);
    });
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(data => {
      this.clientes = data.content;
    }, err => {
      console.error(err);
    });
  }

  buscarMinhasSolicitacoes() {
    this.solicitacaoService.buscarSolicitacoesPorMinhasEmpresas().subscribe(data => {
      console.log(data);
      this.solicitacoesConteudo = data.success ? data.result : [];
      if (data.success) {
        this.searchSolicitacoesConteudo = true;
      } else {
        this.searchSolicitacoesConteudo = false;
      }
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  buscarMinhasSolicitacoesDevolucao() {
    this.solicitacaoService.buscarSolicitacoesPorMinhasEmpresasParaDevolucao().subscribe(data => {
      console.log(data);
      this.solicitacoesConteudo = data.success ? data.result : [];
      if (data.success) {
        this.searchSolicitacoesConteudo = true;
      } else {
        this.searchSolicitacoesConteudo = false;
      }
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  buscarSolicitacaoUnica(id: number) {
    this.solicitacaoService.buscarSolicitacoesUnica(id).subscribe(data => {
      if (data.success) {
        this.clientes.forEach(cliente => {
          if (cliente.id === data.result.cliente) {
            this.solicitacaoForm.get('cliente').setValue(cliente);
            this.listarAreasCliente(cliente.id);
          }
        });
        setTimeout(() => {
          this.areas.forEach(area => {
            if (area.id === data.result.area) {
              this.solicitacaoForm.get('area').setValue(area);
            }
          });
        }, 1000);
        this.solicitacoesConteudo.forEach(solic => {
          if (solic.id.toString() === id.toString()) {
            this.solicitacaoForm.get('dadosAdicionais').setValue(solic.objetoRequisicao);
          }
        });
      } else {
        this.openSnackBarError(data.message);
      }
    }, err => {
      console.error(err);
    });
  }
  selecionarTipoSolic(event: string): void {
    if (event === 'REQUISICAO_CONTEUDO') {
      this.loading = true;
      this.buscarMinhasSolicitacoes();
    }
    if (event === 'DEVOLUCAO_CONTEUDO') {
      this.loading = true;
      this.buscarMinhasSolicitacoesDevolucao();
    }
  }

  selecionarSolicitarConteudo(event: any): void {
    this.solicitacaoForm.get('solicitarConteudoId').setValue(Number(event.toString()));
    this.buscarSolicitacaoUnica(event);
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/adicionar-solicitacao/adicionar-solicitacao.component.ts